<template>
  <div>
    <PageHeader title="Produits irréparables" />
    <Table @view="goToShowPage" :columns="columns" :data="getIndex" :is-accessible="true">
      <template #product="{ row }">
        <div class="flex flex-col">
          <div class="flex items-center text-sm">
            <p>{{ row.product?.title }}</p>
          </div>
          <div class="mt-1 flex items-center">
            <p>
              <strong>Prix d'achat :</strong>
              {{ row.product?.price }} {{ row.product?.currencyCode }}
            </p>
          </div>
        </div>
      </template>
      <template #status="{ row }">
        <FieldSpan
          :value="row.status"
          :style-to-add="statusStyle(row.status)"
          translationPrefix="unfixeable_claim_products.status"
        ></FieldSpan>
      </template>
    </Table>
    <Pagination
      :currentPage="currentPage"
      :totalPages="getTotalPages"
      :totalCount="getTotalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { Table, PageHeader, FieldSpan, Pagination } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { Pagination, FieldSpan, Table, PageHeader },

  async mounted() {
    await this.fetchIndex({ page: this.currentPage });
  },

  data() {
    return {
      currentPage: 1,
    };
  },

  computed: {
    ...mapGetters("unfixeableClaimProducts", ["getIndex", "statusStyle", "getTotalCount", "getTotalPages"]),
    columns() {
      return [
        { label: "Sinistre", field: "claimFriendlyId" },
        { label: "Statut", field: "status", slot: "status" },
        { label: "Valorisation", field: "valuationAmount" },
        { label: "Marchand", field: "store" },
        { label: "Produit", slot: "product", field: "product" },
        { label: "Code de suivi", field: "trackingNumber" },
      ];
    },
  },

  methods: {
    ...mapActions("unfixeableClaimProducts", ["fetchIndex"]),

    goToShowPage(row) {
      this.$router.push(`/unfixeable-claim-products/${row.id}`);
    },

    async handleChangePage(page) {
      this.currentPage = page;
      await this.fetchIndex({ page: this.currentPage });
    },
  },
};
</script>
